import React from "react";
import { View, StyleSheet, Platform, Text, ScrollView } from "react-native";
import appStyles from "../../../appStyles";
import ChecklistItems from "../../animation/info/ChecklistItems";
import AppTheme from "../../AppTheme";
import ManaButton from "../../common/ManaButton";
import TimeSpent from "./TimeSpent";
import CustomizeIcons from "../../common/icons/customize";

export default function Summary({
  isFinalStep = false,
  onContinue = () => {},
  onCustomize = () => {},
}) {
  return (
    <>
      <ScrollView
        style={appStyles.scrollView}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <View
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text style={styles.title}>Welcome to Mana</Text>
          <Text style={styles.subTitle}>You’ve spent:</Text>
          <View
            style={{
              flexDirection: "row",
              alignItems: "flex-end",
            }}
          >
            <TimeSpent />
          </View>
          <Text style={styles.subTitle}>
            getting set up to save hundreds of hours.
          </Text>
        </View>

        <ChecklistItems currentStep={4} />

        <View
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CustomizeIcons.FunCardIcon style={styles.imageBg} />
        </View>
      </ScrollView>

      <View style={[appStyles.footerButtons, { paddingHorizontal: 16 }]}>
        {isFinalStep ? (
          <ManaButton
            isMainButton
            text={"Explore Mana"}
            style={appStyles.bottomButton}
            styleText={appStyles.bottomButtonText}
            onPress={onContinue}
          />
        ) : (
          <>
            <ManaButton
              text={"Continue to Mana"}
              style={[
                appStyles.bottomButtonTwin,
                appStyles.buttonShadow,
                {
                  marginRight: 8,
                  maxWidth: "40%",
                },
              ]}
              styleText={appStyles.bottomButtonTwinText}
              onPress={onContinue}
            />

            <ManaButton
              isMainButton
              text={"Customize Life Elements"}
              style={[appStyles.bottomButtonTwin]}
              styleText={appStyles.bottomButtonTwinText}
              onPress={onCustomize}
            />
          </>
        )}
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.DEFAULT_COLOR,
  },
  subTitle: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  hoursText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 49,
    lineHeight: 60,
    letterSpacing: 0.6125,
    color: AppTheme.DEFAULT_COLOR,
  },
  hoursTextLabel: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 24,
    letterSpacing: 0.6125,
    color: AppTheme.DEFAULT_COLOR,
    paddingBottom: 8,
  },
  imageBg: {
    width: 343,
    maxWidth: "100%",
    height: 267,
    marginTop: 16,
  },
});
